module.exports = __webpack_public_path__ + "img/canada-flag.a39c5875.svg";